import { http, HttpResponse } from "msw";

export const registryHandlersStatic = [
  http.get("*/api/registry/rules", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),
  http.get("*/api/registry/rules/:id", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),
];
